import TemplateView from '../../../../TemplateView'
import messageResource from '../../../../messageResource'
import TabContainer from './TabContainer'
import {bindActionCreators} from 'redux'
import {connect} from '../../../../redux/utils'
import {getCounters, getPanelUserFML, getTab, getUserId, isShowAllAssignScopeContent, isShowCopyContent} from '../selectors'
import {changeWorkAssignmentPanelTab, closeAssignAllScopeContentMenu, closeCopyContentMenu, openAssignAllScopeContentMenu, openCopyMenu} from "../actions"
import {openEditor} from "../../workAssignmentsEditor/actions"
import TabContent from "./TabContent"
import {setEventPreventHidingWorkAssignmentsEditorSlidingPanel} from '../../../../panels/utils'
import CopyContent from './CopyContent'
import ActionsMenuButtons from './action/ActionsMenuButtons'
import AssignAllScopeContent from './AssignAllScopeContent'
import {formatFmlWithCheck} from '../../../../util/UserNameFormat'
import ScollableContainer from '../../../../util/ScrollableContainer'

class WorkAssignmentComponent extends TemplateView {
    constructor({
        onEntityRevoked = () => {},
        onAllRevoked = () => {},
        onSearchChanged = () => {},
        onEditButtonClick = () => {},
        tabChanged = () => {},
        openCopyMenu = () => {},
        closeCopyMenu = () => {},
        openAllAssignScopeMenu = () => {},
        closeAllAssignScopeMenu = () => {},
    }) {
        super()
        this.state = {
            userId: 0,
            userFML: {},
            counters: {
                customers: {
                    curValue: 0,
                    maxValue: 0,
                },
                projects: {
                    curValue: 0,
                    maxValue: 0,
                },
                tasks: {
                    curValue: 0,
                    maxValue: 0,
                },
            },

            showCopyContent: false,
            showAllAssignScope: false,
            openTab: '',
        }

        this.params = {
            onEditButtonClick,
            tabChanged,
            openCopyMenu,
            closeCopyMenu,
            openAllAssignScopeMenu,
            closeAllAssignScopeMenu
        }

        this.onStatePropertyChanged('counters', (counters) => {
            this.tabsContainer.setState(counters)
        })

        this.onStatePropertyChanged('openTab', (tab) => {
            this.tabsContainer.setState({selectedTab: tab})
        })

        this.onStatePropertyChanged('userFML', userFML => {
            this.find('.containerTitle .title').text(messageResource.getMessage('work_assignments.panel.title', [formatFmlWithCheck(userFML)]))
        })

        this.onAnyStatePropertyChanged(['showAllAssignScope', 'showCopyContent'], (state) => {
            const showAllAssignScope = state.showAllAssignScope
            const showCopyContent = state.showCopyContent

            this.$assignAllScopeContent.toggle(showAllAssignScope)
            this.$copyContent.toggle(showCopyContent)

            this.find('.containerHeader').toggle(!showCopyContent && !showAllAssignScope)
            this.find(".tabContentPlaceholder").toggle(!showCopyContent && !showAllAssignScope)
        })
    }


    templateHtml() {
        return '<div class="workAssignmentContainer">' +
               '  <div class="containerTitle">' +
               '    <div class="title"></div>' +
               '    <div class="actions"></div>' +
               '  </div>' +
               '  <div class="assignAllScopeContent"></div>' +
               '  <div class="copyContent"></div>' +
               '  <div class="containerHeader">' +
               '    <div class="tabs"/>' +
               '    <div class="vertical-separator"/>' +
               '    <div class="editButton"><%-editAssignments%></div>' +
               '  </div>' +
               '  <div class="tabContentPlaceholder"/>' +
               '</div>'
    }

    templateModel() {
        return {
            editAssignments: messageResource.getMessage('common.edit'),
            copy: messageResource.getMessage('work_assignments.panel.copy_button'),
        }
    }

    afterRender() {
        this.tabsContainer = new TabContainer({onTabChanged: this.params.tabChanged}).init(this.find('.tabs'))

        this.$editButton = this.find('.editButton')
        this.$editButton.click(e => {
            setEventPreventHidingWorkAssignmentsEditorSlidingPanel(e)
            this.params.onEditButtonClick(this.state.userId)
        })

        this.actions = new ActionsMenuButtons({actions: this._createActionButtonInformation()}).init(this.find('.actions'))

        this.$copyContent = this.find('.copyContent')
        this.copyContent = new CopyContent({
            onCancel: () => {
                this.params.closeCopyMenu()
            },
        })
        this.scrollableCopyContentContainer = new ScollableContainer(null, this.copyContent, {triggerScrollEvent: false}).init(this.$copyContent)

        this.$assignAllScopeContent = this.find('.assignAllScopeContent')
        this.assignAllScopeContent = new AssignAllScopeContent({
            onCancel: () => {
                this.params.closeAllAssignScopeMenu()
            },
        })

        this.scrollableAssignAllScopeContentContainer = new ScollableContainer(null, this.assignAllScopeContent, {triggerScrollEvent: false})
                                                                               .init(this.$assignAllScopeContent)

        this.registerChildComponents(
            this.tabsContainer,
            this.scrollableCopyContentContainer,
            this.scrollableAssignAllScopeContentContainer,
            this.actions,
            new TabContent({onEditButtonClick: () => {
                    this.params.onEditButtonClick(this.state.userId)
                }}).init(this.find(".tabContentPlaceholder")),
        )
    }

    openCopyMenuCallback() {
        this._closeAllPanel()

        if (!this.state.showCopyContent) {
            this.params.openCopyMenu()
        }
    }

    openAllAssignMenuCallback() {
        this._closeAllPanel()

        if (!this.state.showAllAssignScope) {
            this.params.openAllAssignScopeMenu()
        }
    }

    _createActionButtonInformation() {
        return [
            {
                actionClick: this.openAllAssignMenuCallback.bind(this),
                title: messageResource.getMessage('work_assignments.panel.all.assignments'),
                extraClass: 'assignAllScopeButton'
            },
            {
                actionClick: this.openCopyMenuCallback.bind(this),
                title: messageResource.getMessage('work_assignments.panel.copy_button'),
                extraClass: 'copyButtonImg'
            },
        ]
    }

    _closeAllPanel() {
        this.params.closeCopyMenu()
        this.params.closeAllAssignScopeMenu()
    }
}


export default connect(
    state => ({
        userId: getUserId(state),
        userFML: getPanelUserFML(state),
        counters: getCounters(state),
        openTab: getTab(state),
        showCopyContent: isShowCopyContent(state),
        showAllAssignScope : isShowAllAssignScopeContent(state),
    }),
    dispatch => ({
        tabChanged: bindActionCreators(changeWorkAssignmentPanelTab, dispatch),
        onEditButtonClick: bindActionCreators(openEditor, dispatch),
        openCopyMenu: bindActionCreators(openCopyMenu, dispatch),
        closeCopyMenu: bindActionCreators(closeCopyContentMenu, dispatch),
        openAllAssignScopeMenu: bindActionCreators(openAssignAllScopeContentMenu, dispatch),
        closeAllAssignScopeMenu: bindActionCreators(closeAssignAllScopeContentMenu, dispatch),
    })
)(WorkAssignmentComponent)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentPanel/components/WorkAssignmentComponent.js